import { createStyles, makeStyles } from '@material-ui/core/styles';
import { WHITE } from 'constants/colors';
export default makeStyles(theme => createStyles({
  spinnerRoot: {
    textAlign: 'center',
    width: 'auto',
    margin: theme.spacing(3, 'auto')
  },
  autocomplete: {
    margin: '0 auto'
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    // 50% of the size of the spinner (16px)
    marginTop: theme.spacing(-1),
    marginLeft: theme.spacing(-1)
  },
  white: {
    color: WHITE
  }
}));